import React from 'react'
import { formatGuestName, formatSummary, formatTheme } from '../utils/textUtils'

const EpisodeContentFloodcast = ({ episode, compact = false }) => {
  return (
    <>
      {/* Résumé */}
      {episode.summary && !compact && (
        <div className="mb-4">
          <p className="text-text-secondary text-base leading-relaxed px-1">
            {formatSummary(episode.summary)}
          </p>
        </div>
      )}

      {/* Invités et Thèmes abordés */}
      {(episode.guests?.length > 0 || (episode.themes?.length > 0 && !compact)) && (
        <div className="mb-4 flex flex-col sm:flex-row gap-4 items-start">
          {/* Invités */}
          {episode.guests?.length > 0 && (
            <div className="w-full sm:w-1/4 shrink-0 overflow-hidden">
              <h4 className="text-base font-medium text-text-primary mb-4">
                Invités
              </h4>
              <div className="flex flex-wrap gap-3 w-full">
                {episode.guests.map((guest, index) => (
                  <span
                    key={index}
                    className="badge badge-blue px-2 py-1 text-xs text-center max-w-full inline-block mb-2"
                  >
                    {formatGuestName(guest)}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Thèmes abordés */}
          {episode.themes?.length > 0 && !compact && (
            <div className={`overflow-hidden ${episode.guests?.length > 0 ? 'w-full sm:w-3/4' : 'w-full'}`}>
              <h4 className="text-base font-medium text-text-primary mb-4">
                Thèmes abordés
              </h4>
              <div className="flex flex-wrap gap-3 w-full">
                {episode.themes.map((theme, index) => (
                  <span
                    key={index}
                    className="badge badge-purple px-3 py-2 text-sm text-center max-w-full inline-block mb-2"
                  >
                    {formatTheme(theme)}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Version compacte - aperçu rapide */}
      {compact && (
        <div className="mb-6">
          <div className="flex flex-wrap text-sm gap-3">
            {episode.themes?.slice(0, 3).map((theme, index) => (
              <span
                key={index}
                className="badge badge-purple px-3 py-2 mb-2"
              >
                {formatTheme(theme)}
              </span>
            ))}
            {episode.themes?.length > 3 && (
              <span className="badge badge-purple px-3 py-2 mb-2">
                +{episode.themes.length - 3}
              </span>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default React.memo(EpisodeContentFloodcast)